/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AccountSettingResponse } from '../models/AccountSettingResponse';
import type { SystemSettingResponse } from '../models/SystemSettingResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SystemSettingRepository {

  /**
   * システム設定値取得
   * @returns SystemSettingResponse OK
   * @throws ApiError
   */
  public static systemSetting(): CancelablePromise<SystemSettingResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/system_setting',
      errors: {
        500: `Internal Server Error`,
      },
    });
  }

  /**
   * アカウント設定表示
   * @returns AccountSettingResponse OK
   * @throws ApiError
   */
  public static setting(): CancelablePromise<AccountSettingResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/system_setting/account',
      errors: {
        401: `Unauthorized`,
        404: `Not Found`,
        500: `Internal Server Error`,
      },
    });
  }

}
